import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import LoanAgreementAnnexuresPageUI from './LoanAgreementAnnexuresPageUI.js'

class LoanAgreementAnnexuresPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      annexures: null,
    }
  }

  render() {
    return (
      <LoanAgreementAnnexuresPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        annexures={this.state.annexures}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getAnnexures(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  getAnnexures(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/documents/agreement_cum_doh_2/annexures`,
      cacheKey: CacheKeys.Templates(this.props.match.params.loanId, 'loanAgreementAnnexures'),
      callback: this.getAnnexuresCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAnnexuresCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      annexures: response.annexure
    })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loan(this.props.match.params.loanId))
    CacheManager.removeObject(CacheKeys.Templates(this.props.match.params.loanId, 'loanAgreementAnnexures'))
    if (noBusy === 'noBusy') {
      this.getLoan(context)
    }
    else {
      this.setState({
        annexures: null,
        errorList: null,
      })
      this.getLoan(context)
      this.getAnnexures(context)
    }
  }
}

export default withRouter(LoanAgreementAnnexuresPageSF)
